var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 3.5a9 9 0 0 0-8.065 5H7.5a.5.5 0 1 1 0 1h-4A.5.5 0 0 1 3 9V5a.5.5 0 0 1 1 0v2.23a9.99 9.99 0 0 1 8.5-4.73c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.613 0-8.495-3.123-9.65-7.369a.5.5 0 0 1 .965-.262A9 9 0 1 0 12.5 3.5m.5 3a.5.5 0 0 0-1 0v5.586c0 .398.158.78.44 1.06l2.706 2.708a.5.5 0 0 0 .707-.708l-2.707-2.707a.5.5 0 0 1-.146-.353z",
    clipRule: "evenodd"
  })));
});
const SvgHistory = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi40OTk4IDMuNUM4Ljk2Njc2IDMuNSA1LjkwODIgNS41MzU5MSA0LjQzNTE2IDguNUg3LjUwMDA4QzcuNzc2MjMgOC41IDguMDAwMDggOC43MjM4NiA4LjAwMDA4IDlDOC4wMDAwOCA5LjI3NjE0IDcuNzc2MjMgOS41IDcuNTAwMDggOS41SDMuNjc2NjVDMy42NjkgOS41MDAxOCAzLjY2MTMyIDkuNTAwMTggMy42NTM2NCA5LjVIMy41MDAwOEMzLjIyMzk0IDkuNSAzLjAwMDA4IDkuMjc2MTQgMy4wMDAwOCA5VjVDMy4wMDAwOCA0LjcyMzg2IDMuMjIzOTQgNC41IDMuNTAwMDggNC41QzMuNzc2MjMgNC41IDQuMDAwMDggNC43MjM4NiA0LjAwMDA4IDVWNy4yMjkzQzUuNzY0MDIgNC4zOTA3IDguOTEwNjYgMi41IDEyLjQ5OTggMi41QzE4LjAyMjYgMi41IDIyLjQ5OTggNi45NzcxNSAyMi40OTk4IDEyLjVDMjIuNDk5OCAxOC4wMjI4IDE4LjAyMjYgMjIuNSAxMi40OTk4IDIyLjVDNy44ODY5OCAyMi41IDQuMDA0ODQgMTkuMzc3MiAyLjg0OTY5IDE1LjEzMTNDMi43NzcyIDE0Ljg2NDggMi45MzQ0NCAxNC41OSAzLjIwMDkgMTQuNTE3NUMzLjQ2NzM2IDE0LjQ0NSAzLjc0MjEzIDE0LjYwMjMgMy44MTQ2MiAxNC44Njg3QzQuODU0MzUgMTguNjkwNSA4LjM0OTYgMjEuNSAxMi40OTk4IDIxLjVDMTcuNDcwMyAyMS41IDIxLjQ5OTggMTcuNDcwNiAyMS40OTk4IDEyLjVDMjEuNDk5OCA3LjUyOTQ0IDE3LjQ3MDMgMy41IDEyLjQ5OTggMy41Wk0xMi45OTk4IDYuNUMxMi45OTk4IDYuMjIzODYgMTIuNzc1OSA2IDEyLjQ5OTggNkMxMi4yMjM2IDYgMTEuOTk5OCA2LjIyMzg2IDExLjk5OTggNi41VjEyLjA4NThDMTEuOTk5OCAxMi40ODM2IDEyLjE1NzggMTIuODY1MSAxMi40MzkxIDEzLjE0NjRMMTUuMTQ2MiAxNS44NTM2QzE1LjM0MTUgMTYuMDQ4OCAxNS42NTgxIDE2LjA0ODggMTUuODUzMyAxNS44NTM2QzE2LjA0ODYgMTUuNjU4MyAxNi4wNDg2IDE1LjM0MTcgMTUuODUzMyAxNS4xNDY0TDEzLjE0NjIgMTIuNDM5M0MxMy4wNTI1IDEyLjM0NTYgMTIuOTk5OCAxMi4yMTg0IDEyLjk5OTggMTIuMDg1OFY2LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";